import state from "./states/index";
import mutations from "./mutations";
import actions from "./actions";

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/navigation/index.js